// TODO: After Availity SSO is stabilized, analyze the removal of HashRouter
import React, { useEffect } from 'react'
import { getSsoAccessToken } from '_helpers/storage'

const SSORedirectListener: React.FC = () => {
  useEffect(() => {
    const ssoTokenPayload = getSsoAccessToken(window.location.hash)
    if (ssoTokenPayload) {
      window.location.replace(`/#/sso#access_token=${ssoTokenPayload}`)
    } else {
      window.location.replace('/#/login')
    }
  }, [])

  return null
}

export default SSORedirectListener
